import { ACCOUNT_TYPE, fetchUserData, selectUserData } from '../accountSlice'
import { selectWarehouses } from 'containers/Warehouses/warehousesSlice'
import Schedule from 'containers/OrderDetails/Summary/Schedule'
import { useReduxDispatch, useReduxSelector } from 'store'
import { selectUser } from 'containers/Login/loginSlice'
import useTranslation from 'hooks/useTranslation'
import Skeleton from 'react-loading-skeleton'
import { useHistory } from 'react-router-dom'
import React, { useEffect } from 'react'
import { STATUS } from 'utils/constants'
import Error from 'components/Error'

const type = ACCOUNT_TYPE.schedule

const PaymentSchedule: React.FC = () => {
  const user = useReduxSelector(selectUser)
  const warehouses = useReduxSelector(selectWarehouses)
  const { data } = useReduxSelector(state => selectUserData(state, type))
  const { status = STATUS.idle } = useReduxSelector(state => selectUserData(state, type))
  const userHasUnpaidInvoices = Array.isArray(user?.unpaid_invoices) && user.unpaid_invoices.length > 0

  const { push } = useHistory()
  const dispatch = useReduxDispatch()
  const { t } = useTranslation('account')

  useEffect(() => {
    dispatch(fetchUserData(type))
  }, [dispatch])

  return (
    <div>
      <div className='group'>
        <p>{t('paymentSchedule')}</p>
        {userHasUnpaidInvoices
          ? <span
            className='addNew__button --secFont'
            onClick={() => {
              push('/account/invoices?selectAll=1')
            }}>
            {t(user?.unpaid_invoices?.length > 1 ? 'payTheInvoices' : 'payTheInvoice')} →
          </span>
          : (warehouses && warehouses.length > 0)
            ? <span
              className='addNew__button --secFont'
              onClick={() => {
                push('/account/payments/extra')
              }}>
              {t('makeOverpayment')} →
            </span>
            : null}
      </div>
      {data && data?.length > 0
        ? <div className='paymentSchedule'>
          <Schedule schedule={data} />
        </div>
        : <div className='account__list list'>
          {(status === STATUS.succeed || status === STATUS.failed)
            ? <div className='list__element --big'>
              <Error staticPos text={t('noSchedule')} />
            </div>
            : <div className='list__element --big --skeleton'>
              <Skeleton className='skeleton__title' />
              <Skeleton className='skeleton__desc' />
              <Skeleton className='skeleton__title' />
            </div>}
        </div>}
    </div>
  )
}

export default PaymentSchedule